import { Config } from '@crm-in-store/mist-shared-config';

export interface FetchConfig {
  path: string;
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  headers?: Record<string, string>,
  token?: string;
  body?: BodyInit
}
const env = Config.get('env') || 'local';
const baseUrl = `https://api.${env === 'local' ? 'prd' : env}.crm-in-store.eu.pvh.cloud`;

const createHeaders = () => {
  const headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Accept', 'application/json');

  return headers;
};

export const get = <T>(config: FetchConfig): Promise<T> =>
  request({
    method: 'GET',
    ...config
  })
    .then((response) => response?.json());

const request = async (config: FetchConfig) => {
  const headers = new Headers();

  if (config.headers) {
    Object.keys(config.headers).forEach(key => headers.append(key, config.headers![key]));
  }

  return fetch(`${baseUrl}/${config.path}`, {
    body: config.body,
    headers: createHeaders(),
    method: config.method || 'GET'
  }).then(handleResponse);
}

const handleResponse = async (response: Response) => {
  if (response.status >= 200 && response.status <= 204) {
    return response;
  }

  Promise.reject(response);
};

export default { get };
